import React from 'react';
import { Reveal } from './Reveal';

const steps = [
  {
    step: '01',
    title: 'Share Your Footage',
    description: 'Send us your raw clips, ideas, and goals. No videographer? We share filming guidelines to help you capture great footage.'
  },
  {
    step: '02',
    title: 'We Edit & Enhance',
    description: 'Our team cuts, colors, scores, and polishes your footage into scroll-stopping content — with optional AI enhancements.'
  },
  {
    step: '03',
    title: 'Go Live & Grow',
    description: 'Receive your videos in every format you need and launch across platforms to turn attention into local celebrity status.'
  }
];

const Process = () => {
  return (
    <section id="process" className="section-padding bg-[#050505] border-t border-white/5" data-testid="process-section">
      <div className="max-w-7xl mx-auto">
        <Reveal className="text-center max-w-3xl mx-auto mb-16">
          <p className="overline mb-5">How It Works</p>
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-semibold tracking-tight text-white">
            Getting started is <span className="gold-gradient">simple.</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {steps.map((step, index) => (
            <Reveal key={index} delay={index * 0.12}>
              <div
                className="relative h-full bg-[#0f0f0f] border border-white/5 rounded-2xl p-8 md:p-10 overflow-hidden hover:border-[#d4af37]/40 transition-colors duration-500"
                data-testid={`process-step-${index}`}
              >
                <div className="step-numeral absolute -top-2 right-4 select-none pointer-events-none">
                  {step.step}
                </div>
                <div className="relative z-10">
                  <div className="text-[#d4af37] font-display text-2xl font-semibold mb-4">{step.step}</div>
                  <h3 className="text-2xl font-semibold text-white mb-3">{step.title}</h3>
                  <p className="text-[#a0a0a0] leading-relaxed">{step.description}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
